import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Portal from 'routing/Portal';

export const PortalWrapper = ({
	isAuthenticated,
	hasBillingAccess,
	hasProfileAccess,
	hasStorageAccess,
	hasSupportAccess,
	hasColoAccess,
}) => {
	const navigate = useNavigate();
	const location = useLocation();

	function navigateToPath(path, state) {
		navigate(path, state);
	}
	return (
		<Portal
			navigate={navigateToPath}
			location={location}
			isAuthenticated={isAuthenticated}
			hasBillingAccess={hasBillingAccess}
			hasProfileAccess={hasProfileAccess}
			hasStorageAccess={hasStorageAccess}
			hasSupportAccess={hasSupportAccess}
			hasColoAccess={hasColoAccess}
		/>
	);
};
